import React from 'react';
import { Row, Col, Badge } from 'antd';
import styled from 'styled-components';
import UnfulfilledOrdersSection from '../Pagination/UnfulfilledOrdersSection';
import BookingsSection from '../Pagination/BookingsSection';


// Style the container for each section
const SectionContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SectionTitle = styled.h2`
  font-size: 22px;
  font-weight: 600;
  margin: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const OrdersOverview = ({
  unfulfilledOrders,
  fulfilledOrders,
  upcomingBookings,
  completedBookings,
  onFulfill,
  onView,
  onViewFulfillment,
  refreshBookings
}) => {

  const hasHistory = fulfilledOrders.length > 0 || completedBookings.length > 0;

  return (
    <Row gutter={[24, 24]}>
      {/* Pending Orders Section */}
      <Col style={{ padding: '0' }} xs={24}>
        <SectionHeader>
          <SectionTitle>
            Unfulfilled Orders
            <Badge
              count={unfulfilledOrders.length}
              style={{
                backgroundColor: '#000',
                marginLeft: '8px'
              }}
            />
          </SectionTitle>
        </SectionHeader>
        <SectionContainer>
          <UnfulfilledOrdersSection
            orders={unfulfilledOrders}
            onFulfill={onFulfill}
            onView={onView}
            onViewFulfillment={onViewFulfillment}
          />
        </SectionContainer>
      </Col>

      {/* Upcoming Bookings Section */}
      <Col style={{ padding: '0' }} xs={24}>
        <SectionTitle>
          Upcoming Bookings
          <Badge
            count={upcomingBookings.length}
            style={{
              backgroundColor: '#000',
              marginLeft: '8px'
            }}
          />
        </SectionTitle>
        <SectionContainer>
          <SectionHeader>
          </SectionHeader>
          <BookingsSection
            bookings={upcomingBookings}
            refreshBookings={refreshBookings}
            emptyMessage="No upcoming bookings"
          />
        </SectionContainer>
      </Col>

      {/* Only render History section if there's data */}
      {hasHistory && (
        <Col xs={24}>
          <SectionHeader>
            <SectionTitle>History</SectionTitle>
          </SectionHeader>
          <SectionContainer>
            {/* Only render Fulfilled Orders if there are any */}
            {fulfilledOrders.length > 0 && (
              <div style={{ marginBottom: '32px' }}>
                <h3 style={{
                  fontSize: '16px',
                  fontWeight: '500',
                  marginBottom: '16px'
                }}>
                  Fulfilled Orders
                </h3>
                <UnfulfilledOrdersSection
                  orders={fulfilledOrders}
                  onView={onView}
                  onViewFulfillment={onViewFulfillment}
                />
              </div>
            )}

            {/* Only render Completed Bookings if there are any */}
            {completedBookings.length > 0 && (
              <div>
                <h3 style={{
                  fontSize: '16px',
                  fontWeight: '500',
                  marginBottom: '16px'
                }}>
                  Completed Bookings
                </h3>
                <BookingsSection
                  bookings={completedBookings}
                  refreshBookings={refreshBookings}
                  emptyMessage="No completed bookings"
                />
              </div>
            )}
          </SectionContainer>
        </Col>
      )}
    </Row>
  );
};

export default OrdersOverview;